import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wireHotkeyEvents = (engine: TriggerEngine): EventSourceResult => {
  const handler = (e: KeyboardEvent) => {
    const target = e.target as HTMLElement;
    if (
      target.tagName === "INPUT" ||
      target.tagName === "TEXTAREA" ||
      target.isContentEditable
    )
      return;

    if (["Control", "Alt", "Shift", "Meta"].includes(e.key)) return;

    const parts: string[] = [];
    if (e.ctrlKey) parts.push("Ctrl");
    if (e.altKey) parts.push("Alt");
    if (e.shiftKey) parts.push("Shift");
    if (e.metaKey) parts.push("Meta");

    const keyName =
      e.key === " "
        ? "Space"
        : e.key.length === 1
          ? e.key.toUpperCase()
          : e.key;
    parts.push(keyName);

    const combo = parts.join("+");

    engine.fireEvent("hotkey", { combo });
  };

  window.addEventListener("keydown", handler);

  return {
    unsubscribers: [() => window.removeEventListener("keydown", handler)],
  };
};
